export default "__VITE_ASSET__OekX14$v__"